<template>
    <div class="card-container">
        <common-top-form :model="formModel" @success="onSuccess" buttonName="手动拉黑" addShowPower="/blacklist/add" :show="true"
                         :submitService="submitService" :submitData="submitData" @openAddDialog="updateInfo">
                <select-organs v-model="formModel.tatSimpleId" :selectValue="formModel.tatSimpleId"></select-organs>
                <el-form-item label="真实姓名">
                    <el-input type="text" maxlength="20" v-model="formModel.realName" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input type="text" maxlength="20" v-model="formModel.idCard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="会员手机号">
                    <el-input type="text" maxlength="11" v-model="formModel.phone" placeholder="请输入会员手机号"></el-input>
                </el-form-item>
                <el-form-item label="注册时间">
                    <el-date-picker
                        v-model="formModel.time"
                        type="daterange"
                        range-separator="至"
                        :clearable="true"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
        </common-top-form>

        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userName" label="真实姓名" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="idCard" label="身份证号" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="手机号" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
            <!--<el-table-column prop="creator" label="创建人" min-width="160"></el-table-column>-->
            <el-table-column prop="editTime" label="更新时间" min-width="160"></el-table-column>
            <!--<el-table-column prop="editor" label="操作人" min-width="160"></el-table-column>-->
            <el-table-column label="操作" min-width="200" v-if="hasPerm('/blacklist/out') || hasPerm('/blacklist/update')">
                <template slot-scope="scope">
                    <el-button type="text" @click="updateInfo(scope.row.id)" class="button-color" v-if="hasPerm('/blacklist/update')">修改</el-button>
                    <el-button type="text" @click="deleteInfo(scope.row.id)"  v-if="hasPerm('/blacklist/out')">删除</el-button>
                </template>
            </el-table-column>
        </common-table>

        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel"
                     :dialogService="dialogService" :submitData="dialogData" :rules="dialogRules"
                     @success="dialogSuccess" @close="dialogClose" @opend="dialogOpen" class="note">
            <select-organs v-model="dialogModel.tatSimpleId" :selectValue="dialogModel.tatSimpleId" :needAll="false" selectWidth="100%"></select-organs>
            <el-form-item label="身份证号" prop="idCard">
                <el-input type="text" maxlength="20" v-model="dialogModel.idCard" :disabled="!isDisabled" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
                <el-input type="text" maxlength="20" v-model="dialogModel.userName" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="会员手机号">
                <el-input type="text" maxlength="11" v-model="dialogModel.phone" placeholder="请输入会员手机号"></el-input>
            </el-form-item>

            <el-form-item label="描述" prop="remark">
                <el-input maxlength="80" show-word-limit v-model="dialogModel.remark" type="textarea" resize="none"></el-input>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import FormDialog from '../../dialog/FormDialog'

    import MemberService from 'service/MemberService'
    import OrganService from 'service/OrganService'
    import TimeRange from 'service/constant/TimeRange'
    import StatisticsService from 'service/StatisticsService'
    import privateKey from 'service/constant/privateKey';
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "organuser",
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    idCard: '',
                    name: '',
                    phone: '',
                    time: TimeRange.monthRange
                },
                dialogModel: {
                    tatSimpleId: '',
                    idCard: '',
                    phone: '',
                    remark: '',
                    userName: '',
                },
                tableData: [],
                submitService: OrganService.blackList,
                page: {},
                isPage: false,
                blackId:'',
                formDialogTitle:'',
                dialogRules: {
                    idCard: [{
                        required: true,
                        message: '请输入身份证号码'
                    }],
                },
            }
        },
        components: {
            SelectOrgans,
            CommonTopForm,
            FormDialog,
            CommonTable
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        mixins: [loadMixin, dialogMixin],
        computed: {
            isDisabled(){
                return !this.blackId;
            },
            dialogService(){
                return this.blackId ?OrganService.blackUpdate : OrganService.blackAdd
            },
            dialogData(){
                const params = {
                    tatSimpleId: this.dialogModel.tatSimpleId,
                    idCard: this.dialogModel.idCard,
                    phone: this.dialogModel.phone,
                    remark: this.dialogModel.remark,
                    userName: this.dialogModel.userName,
                    userId: this.userId
                };
                if (this.blackId) {
                    params.id = this.blackId;
                }
                return params;
            },
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                const params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    idCard: this.formModel.idCard.trim(),
                    name: this.formModel.name.trim(),
                    phone: this.formModel.phone.trim(),
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                if (this.formModel.time.length) {
                    params.createDateStart = this.formModel.time[0];
                    params.createDateEnd = this.formModel.time[1];
                }
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId','userInfo']),
        },
        methods: {
            doDelete(id) {
                const deleteParams = {
                    id: id,
                };
                this.doLoad(OrganService.blackOut, deleteParams, res => {
                    this.doCheck(res, res => {
                        this.showSuccess(res.respMsg);
                        this.getList();
                    });
                }, '操作失败')
            },
            deleteInfo(id) {
                this.showConfirm('确定移除该会员？').then(() => {
                    this.doDelete(id)
                }).catch(() => {
                });
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(data) {
                this.doCheck(data, res => {
                    const result = res.contents;

                    this.tableData = result.records;
                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                });
            },
            dialogSuccess(data){
                this.doCheck(data, res => {
                    this.showSuccess(res.respMsg)
                    this.$refs.formDialog.closeDialog();
                    this.getList();
                })
            },
            dialogClose(){
                this.blackId= '';
                this.dialogModel = {
                    tatSimpleId: '',
                    idCard: '',
                    phone: '',
                    remark: '',
                    userName: '',
                }
            },
            dialogOpen(){
                if (this.blackId) {
                    this.tableData.forEach(item => {
                        if (item.id == this.blackId) {
                            this.dialogModel = JSON.parse(JSON.stringify(item));
                        }
                    })
                }
            },
            updateInfo(id){
                this.blackId = id;
                this.formDialogTitle = this.blackId ? '修改黑名单' : '添加黑名单';
                this.$refs.formDialog.open();
            }
        },
    }
</script>

<style scoped>
    .parent-box{
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/OrganBlack.vue